export enum DateFormats {
    LongDateTimeFormat_MMDDYYYY_hhmmssA = "MM/DD/YYYY hh:mm:ss A",
    LongDateTimeFormat_MMDDYYYY_HHmmss = "MM/DD/YYYY HH:mm:ss",
    LongDateTimeFormat_MMDDYYYY_HHmm = "MM/DD/YYYY HH:mm",
    LongDateTimeFormat_DMMYYYY_hhmmssA = "D/MM/YYYY hh:mm:ss A",
    LongDateTimeFormatFile_MMDDYYYYHHmmss = "MMDDYYYYHHmmss",
    LongDateFormat_ddddMMMMDYYYY = "dddd, MMMM D, YYYY",
    LongDateFormat_MMDDYYYY = "MM/DD/YYYY",
    LongDateFormat_YYYYMMDD = "YYYY-MM-DD",
    LongDateFormat_dddd_MMMM_D_YYYY = "dddd, MMMM D, YYYY",
    LongDateTimeFormat_YYYYMMDD_HHmm = 'YYYY-MM-DD HH:mm',
    LongDateTimeFormat_YYYYMMDD_HHmmss = 'YYYY-MM-DD HH:mm:ss',
    LongDateTimeFormat_YYYYMMDD_HHmmssSSS = 'YYYY-MM-DD HH:mm:ss.SSS',
    ShortTimeFormat_HHmmss = "HHmmss",
    ShortTimeFormat_HHmm = "HH:mm",
    ShortTimeFormat_hhmmssA = "hh:mm:ss A",
    ShortTimeFormat_hhmmA = "hh:mm A",
    ShortTimeFormat_hhmmss = "HH:mm:ss",
    AspNetDateTimeFormat = "YYYY-MM-DDTHH:mm:ss"
}
